module.exports = __webpack_public_path__ + "img/temper.93715af8.svg";